import React from 'react';
import Typography from '@src/new-components/Typography';
import GiftDubbing from '@src/assets/images/gift-dubbing.png';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { StyledAlert, StyledStepProgessBar } from './index.style';

const StepProgressBar = ({
  amountStep = 3,
  activeStep,
  onPrevious,
  hasButtonPreviousDisabled,
  onSkip,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{ width: '100%' }}>
      <StyledAlert>
        <img
          style={{ width: '20px', height: '20px' }}
          src={GiftDubbing}
          alt="Gift Dubbing"
        />
        <Typography
          variant="body-14-regular"
          className="alert-survey"
          color={COLOR.descriptionGray}
          dangerouslySetInnerHTML={{
            __html: t('alertSurvey', {
              credits: 2000?.toLocaleString(language),
            }),
          }}
        />
      </StyledAlert>

      <StyledStepProgessBar isMobile={isMobile}>
        {isMobile && (
          <ArrowBackRoundedIcon
            onClick={() => {
              if (hasButtonPreviousDisabled) return;
              onPrevious();
            }}
            className={hasButtonPreviousDisabled && 'disabled-prev-btn'}
          />
        )}
        <div className="container-step">
          {[...Array(amountStep).keys()].map((step) => (
            <div
              key={step}
              className={`step ${activeStep === step && 'active-step'}`}
            />
          ))}
        </div>
        {isMobile && (
          <div
            role="button"
            onClick={onSkip}
            tabIndex="0"
            className="skip-action"
          >
            {t('later')}
          </div>
        )}
      </StyledStepProgessBar>
    </div>
  );
};

export default StepProgressBar;
